import React from "react";
import {
    useState
} from 'react'

import {
    Navigate,
    useNavigate,
    Link
} from 'react-router-dom';
// import FacebookLogin from 'react-facebook-login';
import { useGoogleLogin } from '@react-oauth/google';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// styles
import './style.css';
//components
import Input from "../../components/Inputs/Control";
import {
    FaChevronLeft, FaUserPlus
} from "react-icons/fa";
// api
import { signup, signUpGoogle } from "../../api/auth";
import { removeUserSession } from '../../utils/common';

import { useAppStore } from "../../context/state";
const isAuth =  useAppStore.getState().isAuth

const RegisterForm = ({gclientId, lang}) => {

    let history = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        firstName: "",
        lastName: "",
        password: "",
        userPhone: "",
        userMobile: "",
        birthDate:"",
        documentNumber:"",
        country: "",
        city: "",
        language: lang.key,
        urlTwitter: "",
        urlFacebook: "",
        message: {}
    });
    const [isValid, setValidate] = useState(false)

    const handleOnchange = (event) => {
        const {
            name,
            value
        } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });

    };

    const handleOnBlur = (event) => {
        const { id } = event.target;
        setFormData({
            ...formData,
            ...{message:{}}
        });
        validateInputField(id);
    };

    const validateInputField = (name) => {
        if (name === "email") {
            setValidate(validEmail());
        } else if (name === "firstName") {
            setValidate(validFirstName());
        } else if (name === "lastName") {
            setValidate(validLastName());
        } else if (name === "birthDate") {
            setValidate(valiBirthDate());
        }
        return isValid
    };

    const validEmail = () => {
        let value = formData.email;
        if (value === "") {
            setFormData({
                ...formData,
                ...{message: {"email":{"type":"text-warning", "text":lang.register_emaileerror}}}
            });
            return false;
        }
        return true;
    };

    const validFirstName = () => {
        let value = formData.firstName;
        if (value === "") {
            setFormData({
                ...formData,
                ...{message: {"firstName":{"type":"text-warning", "text":lang.register_nameerror}}}
            });
            return false;
        }
        return true;
    };

    const validLastName = () => {
        let value = formData.lastName;
        if (value === "") {
            setFormData({
                ...formData,
                ...{message:{"lastName":{"type":"text-warning", "text":lang.register_lastnameerror}}}
            });
            return false;
        }
        return true;
    };
    const valiBirthDate = () => {
        let value = formData.birthDate;
        if (value === "") {
            setFormData({
                ...formData,
                ...{message: {"birthDate":{"type":"text-warning", "text":lang.register_birtherror}}}
            });
            return false;
        }
        return true;
    };

    const registerWithGoogle = useGoogleLogin({
        clientId:gclientId,
        onSuccess: data => {
            signUpGoogle(data).then((response) => {
                const { token, user } = response.data;
                sessionStorage.setItem('token', token);
                sessionStorage.setItem('user', JSON.stringify(user));
                history('/editorial/user-access');
            })
        },
        onError: response => {
            toast.success('No puede registrar su cuenta usando Google.', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!isValid) return;
        let customId = true;
        signup(formData)
            .then(function (response) {
                toast.success(lang.register_success, {
                    toastId: customId,
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    pauseOnFocusLoss: false,
                    closeOnClick: false,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    onClose: () => {
                        if(!customId) history('/editorial/user-access')
                        customId = null;
                    }
                });

            }).catch(function (error) {
                let {message, multiple} = error.response.data
                        ? error.response.data.error
                        : {message:error.code, multiple:false};

                if(multiple){
                    message.map((item)=>
                        toast.error(lang[item.message], {
                            toastId: item.message,
                            position: "top-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            pauseOnFocusLoss: false,
                            closeOnClick: false,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined
                        })
                    )
                }else{
                    toast.error(lang[message], {
                        toastId: message,
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        pauseOnFocusLoss: false,
                        closeOnClick: false,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined
                    })
                }
                removeUserSession();
            });

    }

    return (
        <div>
            { isAuth  ?
                (<Navigate replace to="/editorial/user-profile" />) : (
            <div className="register-wrap">
            <p>{lang.register_networks}</p>
            <div>
                <Button variant="primary" size="sm">
                    Facebook
                </Button>{' '}
                <Button variant="secondary" size="sm" onClick={() => registerWithGoogle()}>
                    Google+
                </Button>
            </div>
            <p>{lang.register_forms}</p>
            <Form onSubmit={handleSubmit}>
            <Row>
            <Col sm={12} md={8}>
                <Input
                    onChange={handleOnchange}
                    onBlur={handleOnBlur}
                    message={formData.message}
                    value={formData.email}
                    id="email"
                    type="email"
                    label={lang.register_email}
                    placeholder={lang.register_placeholderemail}
                    className="w100"
                />
            </Col>
            <Col sm={12} md={4}>
                <Input
                    onChange={handleOnchange}
                    onBlur={handleOnBlur}
                    message={formData.message}
                    value={formData.birthDate}
                    id="birthDate"
                    type="date"
                    label={lang.register_birth}
                    placeholder={lang.register_placeholderbirth}
                    className="w100"
                />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6}>
                <Input
                    onChange={handleOnchange}
                    onBlur={handleOnBlur}
                    message={formData.message}
                    value={formData.firstName}
                    id="firstName"
                    type="text"
                    label={lang.register_name}
                    placeholder={lang.register_placeholdername}
                    className="w100"
                />
                </Col>
                <Col sm={12} md={6}>
                <Input
                    onChange={handleOnchange}
                    onBlur={handleOnBlur}
                    message={formData.message}
                    value={formData.lastName}
                    id="lastName"
                    type="text"
                    label={lang.register_lastname}
                    placeholder={lang.register_placeholderlastname}
                    className="w100"
                />
                </Col>
            </Row>
                <div>
                    <small>
                        <p className="text-justify">
                        Al registrarse en nuestro sistema; dando cumplimiento a la Ley 1581 de 2.012 y su Decreto Reglamentario 1377 de 2.013, le informamos que los datos
    personales de su propiedad, serán tratados, almacenados, usados y procesados en nuestra base de datos, cuya finalidad es gestionar el envío por
    nuestra partes de bienes y/o servicios y hacerle partícipe de nuestros eventos promocionales. <br/>
    EL PROGRAMA EDITORIAL DE LA UNIVERSIDAD DEL VALLE garantiza el ejercicio de los derechos de acceso, rectificación, cancelación y oposición de los datos facilitados. Si desea consultar o eliminar sus datos, puedo hacerlo mediante
    comunicación escrita dirigida al correo electrónico programa.editorial.ayuda@correounivalle.edu.co
                        </p>
                        <Form.Check type="checkbox" label={lang.register_checkaccept} required/>
                    </small>

                    <Button variant="outline-secondary" onClick={()=> history(-1)}>
                        <FaChevronLeft/> {' '} {lang.register_btncancel}
                    </Button>{' '}
                    <Button variant="primary" type="submit" disabled={!isValid}>
                        <FaUserPlus/>  {' '} {lang.register_btnregister}
                    </Button>{' '}
                    {lang.register_already} <Link to="/editorial/user-access"> {lang.register_back}</Link>
                </div>
            </Form>
            </div>
        )}
        </div>
    );
};

export default RegisterForm;
